module.exports = __webpack_public_path__ + "img/Figure-6-28-min.b96db061.jpg";